
  $(function() {
    $(".description p").each(function(){
        var el = $(this);
        var wordArray = el.innerHTML.split(' ');
        while(el.scrollHeight > el.offsetHeight) {
            wordArray.pop();
            el.innerHTML = wordArray.join(' ')  + '...';
        }
    });
  });

  registerFeedClick = function(idFeed, idProvider, idCategory){
    $.ajax({
      url: '/registerFeedClick',
      type: "post",
      data: {'idFeed': idFeed, 'idProvider': idProvider, 'idCategory': idCategory},
      success: function(data){
        console.log(data);
      },
      error: function(e){console.log(e);}
    });
  };
